<span [title]="statusString | async">
  &copy; {{ year }} {{isPropak ? 'Propak' : 'Pallet Logistics of America' }}
</span>
